<template>
  <div>
    <div
      class="search_result"
      :key="'text_' + text.id"
      v-for="text in mutable_results"
    >
      <div class="is-flex is-align-items-center">
        <p><b>Designator:</b></p>
        <div class="horizontal_space"></div>
        <resource-text-editor :payload="{ text_data: text, designator: text.designator, resource_type: text.resource.resource_type, resource_id: text.resource.resource_id  }">
        </resource-text-editor>
      </div>
      <div>
        <div class="is-flex is-align-items-center">
          <p><b>Applicant Name:</b></p>
          <div class="horizontal_space"></div>
          <link-entity :payload="text.resource" :additional_data="{ resource_type: 'Applicant' }"></link-entity>
        </div>
        <p><b>Content: </b></p>
        <p class="text_content" v-html="$sanitize(text.content)"></p>
      </div>
    </div>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
import LinkEntity from '@/components/LinkEntity'
import ResourceTextEditor from '@/components/ResourceTextEditor'
export default {
  name: 'search-modal-texts',
  props: ['results'],
  data () {
    return {
      time_helper: new TimeHelper(),
      mutable_results: this.results
    }
  },
  watch: {
    results () {
      this.mutable_results = this.results
    }
  },
  created () {
    this.mutable_results = []
  },
  components: {
    LinkEntity,
    ResourceTextEditor
  }
}
</script>
<style>
  .search_result {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .text_content{
    white-space: pre-line;
    word-break: break-word;
  }
</style>
